export enum LevelType {
    Core = 'core',
}

export type tPlayerLevelMap = Record<LevelType, IPlayerLevelData[]>;

export interface IPlayerLevelData {
    levelNumber: number;
    /**
     * The number of stars earned after complete the level (1-3).
     */
    stars?: number;
    /**
     * The number of level attempts ever.
     */
    attempts?: number;
    /**
     * The number of level attempts per session, since last helper-friend activated.
     */
    helperFriendAttempts?: number;
    /**
     * The number of level attempts per session, since last completed.
     */
    consecutiveUnsuccessfullAttempts?: number;
}
